import { createFileRoute } from "@tanstack/react-router";
import { MfeLoader } from "../mfe/MfeLoader";
import { getAgentRuntimeAuthzHostConfig } from "../config/agentRuntimeAuthzHostConfig";
import { useHostNavigate } from "../hooks/useHostNavigate";
import { usePermissionState } from "../contexts/PermissionStateContext";

export const Route = createFileRoute("/agent-runtime-authz/")({
  component: AgentRuntimeAuthzMfePage,
});

function AgentRuntimeAuthzMfePage() {
  const onNavigate = useHostNavigate();
  const permissionState = usePermissionState();
  return (
    <MfeLoader
      name="agent-runtime-authz"
      props={{
        hostConfig: getAgentRuntimeAuthzHostConfig(onNavigate, permissionState),
      }}
    />
  );
}
